export const DashIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  ...props
}: any) => (
  <svg {...props} width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g id="Icons All">
      <path
        id="Vector"
        d="M3.25 9.20825H22.75M9.20825 22.7499V9.20825M4.875 3.25H21.125C22.0225 3.25 22.75 3.97754 22.75 4.875V21.125C22.75 22.0225 22.0225 22.75 21.125 22.75H4.875C3.97754 22.75 3.25 22.0225 3.25 21.125V4.875C3.25 3.97754 3.97754 3.25 4.875 3.25Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
